import React from "react";

const WhatsAppButton = () => {
  const whatsappNumber = "923435628108";
  const message = "Hello! I would like to know more.";

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        message
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      className="
        fixed
        bottom-3 right-3
        sm:bottom-4 sm:right-4
        md:bottom-5 md:right-5
        w-12 h-12
        sm:w-14 sm:h-14
        md:w-16 md:h-16
        rounded-full
        bg-[#25D366]
        flex items-center justify-center
        shadow-lg
        hover:scale-110
        transition-all duration-300
        z-50
      "
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        className="
          w-6 h-6
          sm:w-8 sm:h-8
          md:w-9 md:h-9
        "
      />
    </a>
  );
};

export default WhatsAppButton;